module.exports = __webpack_public_path__ + "static/media/logo.4d72c4b8.png";